import { TypeConnection } from '~/constants/connections'

// Enhanced connection type for local repositories
export interface LocalConnection {
  id: 'local'
  name: string
  icon: JSX.Element
  description?: string
  hideConn?: boolean
}

// Union type for all connection types
export type ConnectionUnion = TypeConnection | LocalConnection

export interface ConnectionApikey {
  token: string
  baseUrl: string
}

// Page state enum
export enum PageView {
  CARD_LIST = 'card_list',
  INDEX_DETAIL = 'index_detail',
  INDEX_MODAL = 'index_modal'
}

export interface FileInfo {
  name: string
  size: number
}

export type UploadState = {
  status: 'uploading' | 'uploaded' | 'error' | null
  progress?: number
  error?: string
  file?: FileInfo
  virusScanStatus?: string
  virusScanMessage?: string
}
